import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useGetPoolOptions } from '../../../../Tables/Settings/PlanUnits/components/utils/useGetPoolOptions';
import { toOptions } from 'utils/toOptions';

import ControlledMultiSelect from 'components/shared/ControlledFields/ControlledMultiSelect';

import {
  useGetClusters,
  useGetContracts,
  useGetCostCentersWithGivenInterval,
  useGetEmployees
} from '../../../../../../queries';
import {
  ControlledCheckboxAutoComplete,
  ControlledSelect
} from '../../../../../shared';
import HourPerPlanUnitSection from './HourPerPlanUnitSection';
import { Box } from '@mui/material';
import { onRemoveElement } from '../utils/onRemoveElement';

const BaseSection = ({ hasEmployee = false, hasSourceCostCenter = false }) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.procedures.reports'
  });
  const { control, setValue, getValues, watch } = useFormContext();
  const { data: pools } = useGetPoolOptions();
  const { data: clusters } = useGetClusters();
  const { data: contracts } = useGetContracts();
  const { data: employees } = useGetEmployees(!hasEmployee);
  const { data: customerCostCenter } = useGetCostCentersWithGivenInterval(
    getValues('valid_from'),
    getValues('valid_to'),
    !hasSourceCostCenter
  );

  return (
    <>
      <HourPerPlanUnitSection />
      {hasSourceCostCenter && (
        <Box>
          <ControlledCheckboxAutoComplete
            fullWidth
            name="emp_br_id_list"
            label={t('sourceCostCenter')}
            variant="outlined"
            options={customerCostCenter ?? []}
            control={control}
            idProperty="value"
            labelProperty="label"
            allowItemRemoval
            onRemoveElement={(id) =>
              onRemoveElement(setValue, watch, 'emp_br_id_list', id)
            }
          />
        </Box>
      )}
      {!hasEmployee && (
        <ControlledMultiSelect
          fullWidth
          name="emp_id_list"
          label={t('employee')}
          variant="outlined"
          options={employees ?? []}
        />
      )}
      <ControlledSelect
        variant="outlined"
        control={control}
        name="pool_list"
        label={t('pool')}
        options={pools}
      />
      <ControlledSelect
        variant="outlined"
        control={control}
        name="cluster_list"
        label={t('cluster')}
        options={toOptions(clusters ?? [], 'clusterId', 'name')}
      />
      <ControlledMultiSelect
        fullWidth
        name="contract_list"
        label={t('contract')}
        variant="outlined"
        options={contracts ?? []}
      />
    </>
  );
};

export default BaseSection;
